<template>
  <div id="archives">
    <touch @swipeup="next" @swipedown="prev">
      <transition-group tag="article" :name="pageTransitionName" @after-enter="transitionComplete">
        <section v-show="pageList[current] === 1" key="page-1" class="page page-1">
          <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
          <aside class="arrow"></aside>
          <div class="page-inner">
            <div class="block">
              <div class="avatar">
                <webp-image :src="avatar" alt="avatar" />
              </div>
              <div class="infor">
                姓名:<span class="name">{{ name }}</span><br>
                流利号:<span class="id">{{ id }}</span>
              </div>
            </div>
            <div class="comment">
              <p v-if="shared"><strong class="name">{{ nickCutOff(name) }}</strong>同志于 <strong>{{ formatDate(createdAt * 1000) }}</strong><br>自愿加入英语流利说，立志提升英语水平，力争成为一名合格的国际公民。</p>
              <p v-else>亲爱的 <strong class="name">{{ nickCutOff(name) }}</strong>，<br>你于 <strong>{{ formatDate(createdAt * 1000) }}</strong><br>自愿加入英语流利说，立志提升英语水平，力争成为一名合格的国际公民。</p>
            </div>
            <div class="poster">
              <webp-image src="https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/gjgm-gHhwgLy2.png" />
            </div>
          </div>
        </section>
        <section v-show="pageList[current] === 2" key="page-2" class="page page-2">
          <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
          <aside class="arrow"></aside>
          <div class="page-inner">
            <div class="data">
              <p>在过去的一年中，<br>{{ who }}总共学习了 <strong><i-count-up :start="0" :end="countUps.activeDaysCount" :duration="2"/></strong> 天，<br>合计 <strong><i-count-up :start="0" :end="countUps.totalMinutes" :duration="2"/></strong> 分钟，录音 <strong><i-count-up :start="0" :end="countUps.recordSentencesCount" :duration="2"/></strong> 句子，相当于 <strong>{{ countUps.bookCount }}</strong> 本《共产党宣言》</p>
            </div>
            <div class="title">
              <p>经组织评定,光荣获得了 <strong>{{ tag.title }}</strong> 称号 </p>
            </div>
            <div class="comment">
              <p><strong>{{ tag.comment }}</strong></p>
            </div>
            <div class="poster">
              <div class="light"></div>
              <webp-image class="image" :src="tag.image" />
            </div>
          </div>
        </section>
        <section v-show="pageList[current] === 3" key="page-3" class="page page-3">
          <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
          <aside class="arrow"></aside>
          <div class="page-inner">
            <div class="data">
              <p>经过一整年的努力<br>{{ who }}的口语力达到 <strong><i-count-up :start="0" :end="countUps.speakingForce" :duration="2"/></strong> <br>闯关平均分达到 <strong><i-count-up :start="0" :end="countUps.dialogAvgScore" :duration="2"/></strong> 分</p>
            </div>
            <div class="block">
              <p>经组织评估</p>
            </div>
            <div class="block">
              <p>{{ who }}的英语水平击败全国 <strong><i-count-up :start="0" :end="countUps.defeatRate" :duration="2"/>%</strong> 的同志!</p>
            </div>
            <div class="honor">
              <p><strong>{{ honor.title }}</strong></p>
            </div>
            <div class="poster">
              <webp-image :src="honor.image" />
            </div>
          </div>
        </section>
        <section v-show="pageList[current] === 4" key="page-4" class="page page-4">
          <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
          <aside class="arrow"></aside>
          <div class="page-inner">
            <div class="behavior">
              <p>{{ who }}擅长 <strong>{{ goodAt }}</strong></p>
            </div>
            <div class="comment">
              <p><strong>{{ habit.comment }}</strong></p>
            </div>
            <div class="poster">
              <webp-image :src="habit.image" />
            </div>
          </div>
        </section>
        <section v-show="pageList[current] === 5" v-if="checkinDaysCount >= 30" key="page-5" class="page page-5">
          <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
          <aside class="arrow"></aside>
          <div class="page-inner">
            <div class="data">
              <p>{{ who }}本年度<br>累计打卡 <strong><i-count-up :start="0" :end="countUps.checkinDaysCount" :duration="2"/></strong> 天</p>
            </div>
            <div class="comment">
              <p>只要学不死，就往死里学<br>组织向奋战多日的{{ who }}致以<br><strong>崇高的敬意！</strong></p>
            </div>
            <div class="poster">
              <webp-image src="https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/perseverance-Wddg6Cg5.png" />
            </div>
          </div>
        </section>
        <section v-show="pageList[current] === 6" key="page-6" class="page page-6">
          <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
          <aside class="arrow"></aside>
          <div class="page-inner">
            <div class="data">
              <p>一年的艰苦努力，<br>{{ who }}在流利说收获 <strong><i-count-up :start="0" :end="countUps.coins" :duration="2"/></strong> 枚金币</p>
            </div>
            <div class="comment">
              <p><strong>{{ wealth.first }}<br>{{ wealth.second }}</strong></p>
            </div>
            <div class="poster">
              <webp-image :src="wealth.image" />
            </div>
          </div>
        </section>
      </transition-group>
    </touch>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import ICountUp from 'vue-countup-v2'
  import WebpImage from '@/components/common/WebpImage'

  const PAGE_MAP = {
    1: 'user_strat_time',
    2: 'report_study_time',
    3: 'report_average_score',
    4: 'report_study_period',
    5: 'report_check_days',
    6: 'report_coin'
  }

  export default {
    name: 'page-archives',
    data () {
      return {
        current: 0,
        pageTransitionName: 'page-down',
        countUps: {
          activeDaysCount: 0,
          totalMinutes: 0,
          recordSentencesCount: 0,
          bookCount: 0,
          speakingForce: 0,
          dialogAvgScore: 0,
          defeatRate: 0,
          checkinDaysCount: 0,
          coins: 0
        }
      }
    },
    computed: {
      ...mapState({
        musicPlaying: state => state.musicPlaying,
        id: state => state.data.login,
        name: state => state.data.nick,
        avatar: state => state.data.avatar,
        createdAt: state => state.data.createdAt,
        checkinDaysCount: state => state.data.reports.checkinDaysCount,
        activeDaysCount: state => state.data.reports.activeDaysCount,
        totalMinutes: state => state.data.reports.totalMinutes,
        recordSentencesCount: state => state.data.reports.recordSentencesCount,
        speakingForce: state => state.data.reports.speakingForce,
        dialogAvgScore: state => state.data.reports.dialogAvgScore,
        defeatRate: state => state.data.reports.defeatRate,
        goodAt: state => state.data.reports.goodAt,
        coins: state => state.data.reports.coins
      }),
      pageList () {
        return this.checkinDaysCount >= 30 ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 6]
      },
      shared () {
        return !!this.$store.state.urlParams.shareId
      },
      who () {
        return this.$store.state.urlParams.shareId ? '该同志' : '你'
      },
      tag () {
        if (this.activeDaysCount >= 300) {
          return {
            title: '学魔',
            comment: '该同志废寝忘食，只争朝夕，日后必成大器！',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/xuemo-McpUFufM.png'
          }
        } else if (this.activeDaysCount >= 200) {
          return {
            title: '学神',
            comment: '该同志艰苦耐劳，发愤图强，组织予以表彰！',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/xueshen-MxlkZPVw.png'
          }
        } else if (this.activeDaysCount >= 30) {
          return {
            title: '学霸',
            comment: '该同志刻苦认真，严于律己，望你继续努力！',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/xueba-wbhsXM9j.png'
          }
        } else {
          return {
            title: '学酥',
            comment: '该同志自由散漫，作风享乐，组织拿你没辙……',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/xuesu-S56lYxhS.png'
          }
        }
      },
      honor () {
        if (this.defeatRate >= 70) {
          return {
            title: '［ 全校大会通报表扬 ］',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/4-CFPmA4Ju.png'
          }
        } else if (this.defeatRate >= 50) {
          return {
            title: '［荣当流利说奔北坡标兵］',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/3-TgmpzITs.png'
          }
        } else if (this.defeatRate >= 30) {
          return {
            title: '［ 荣获口语角流动红旗 ］',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/2-caehFJ62.png'
          }
        } else {
          return {
            title: '［特授一朵小红花以资鼓励］',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/1-1T8I7Bh7.png'
          }
        }
      },
      habit () {
        if (this.goodAt === '深夜苦读') {
          return {
            comment: '睡得比🐶晚，练就了一双国宝级熊猫眼。',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/1-fJGVqKs8.png'
          }
        } else if (this.goodAt === '晨起开嗓') {
          return {
            comment: '醒得比🐓早，生物钟超前领跑。',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/6-scamPyBl.png'
          }
        } else if (this.goodAt === '见缝插针') {
          return {
            comment: '能充分发挥主观能动性，课余时间，分秒必争。',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/5-u8HadX6F.png'
          }
        } else if (this.goodAt === '饭后用功') {
          return {
            comment: '人是铁，饭是钢，吃饱才能开洋腔。',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/4-AVADyq7B.png'
          }
        } else {
          return {
            comment: '自从学了英语，睡觉都比别人香啦！',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/3-IEMpBb9i.png'
          }
        }
      },
      wealth () {
        if (this.coins > 3000) {
          return {
            first: '喝酸奶不舔盖儿，',
            second: '煎饼果子加俩蛋 ~',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/2-BHiQoe9p.png'
          }
        } else if (this.coins > 500) {
          return {
            first: '勤俭节约艰苦奋斗，',
            second: '努力做个富一代！',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/7-fyiZLMZn.png'
          }
        } else {
          return {
            first: '穷得揭不开锅了，',
            second: '年夜饭给点土吃成吗？',
            image: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/tags/8-Jar6eRlh.png'
          }
        }
      }
    },
    created () {
      this.$track.sendPageTrack(PAGE_MAP[this.pageList[this.current]])
    },
    methods: {
      prev () {
        if (this.current > 0) {
          this.pageTransitionName = 'page-down'
          this.current--
          this.$track.sendPageTrack(PAGE_MAP[this.pageList[this.current]])
        }
      },
      next () {
        if (this.current + 1 === this.pageList.length) {
          this.$router.push('summary')
        } else {
          this.pageTransitionName = 'page-up'
          this.current++
          this.$track.sendPageTrack(PAGE_MAP[this.pageList[this.current]])
        }
      },
      transitionComplete () {
        if (this.pageList[this.current] === 2) {
          this.countUps.activeDaysCount = this.activeDaysCount
          this.countUps.totalMinutes = this.totalMinutes
          this.countUps.recordSentencesCount = this.recordSentencesCount
          this.countUps.bookCount = this.roundNumber(this.recordSentencesCount / 2142, 1)
        } else if (this.pageList[this.current] === 3) {
          this.countUps.speakingForce = this.speakingForce
          this.countUps.dialogAvgScore = this.dialogAvgScore
          this.countUps.defeatRate = this.defeatRate
        } else if (this.pageList[this.current] === 5) {
          this.countUps.checkinDaysCount = this.checkinDaysCount
        } else if (this.pageList[this.current] === 6) {
          this.countUps.coins = this.coins
        }
      },
      playOrPause () {
        this.$emit('playOrPauseBgMusic')
      },
      formatDate (timeStr) {
        const date = new Date(timeStr)
        const year = date.getFullYear() // 获取完整的年份(4位,1970)
        const month = date.getMonth() + 1 // 获取月份(0-11,0代表1月,用的时候记得加上1)
        const day = date.getDate() // 获取日(1-31)

        return `${year}年 ${month}月 ${day}日`
      },
      roundNumber (number, digit) {
        if (number >= 0) {
          return parseInt((number * Math.pow(10, digit) + 0.5)) / Math.pow(10, digit)
        } else {
          return -parseInt((-number * Math.pow(10, digit) + 0.5)) / Math.pow(10, digit)
        }
      },
      nickCutOff (nick) {
        return nick.length > 8 ? `${nick.substring(0, 8)}...` : nick
      }
    },
    components: {
      WebpImage,
      ICountUp
    }
  }
</script>

<style lang="scss">
  $paper: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/paper-WtxrklAJ.png';
  $border: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/border-UcNzeP9P.png';
  $arrow: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/arrow-rDL9mBQM.png';
  $light: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/light-rh6rYKAI.png';

  #archives {
    article {
      position: relative;
      width: 100%;
      height: 100%;
    }
    .page {
      @include bg-image-contain($paper);
      width: 750px;
      height: 1188px;
      padding-left: 60px;
      padding-right: 60px;
      padding-top: 126px;
      box-sizing: border-box;
      .arrow {
        @include bg-image-cover($arrow);
        position: absolute;
        bottom: 40px;
        left: 50%;
        z-index: 14;
        width: 88px;
        height: 60px;
        margin-left: -44px;
        animation: arrow 0.7s infinite ease-in-out;
        animation-direction: alternate;
      }
      .page-inner {
        @include bg-image-contain($border);
        position: relative;
        width: 644px;
        height: 1027px;
        padding: 80px 45px;
        box-sizing: border-box;
        .block {
          display: flex;
          p {
            font-size: 40px;
          }
        }
        p {
          font-size: 35px;
          color: $red;
          line-height: 50px;
          strong {
            font-size: 40px;
            color: $darkBlue;
          }
        }
      }
      .poster {
        position: absolute;
        left: 45px;
        bottom: 74px;
        width: 550px;
        font-size: 0;
        animation: zoomInOut 1.2s ease-in-out;
      }
      .id,
      .name {
        font-family: Helvetica,Tahoma,Arial,'PingFang SC','Microsoft YaHei','Hiragino Sans GB',SimSun,Heiti,sans-serif;
      }
    }
    .page-1 {
      .avatar {
        width: 180px;
        height: 180px;
        font-size: 0;
        border: 6px solid $red;
      }
      .infor {
        margin-top: 70px;
        margin-left: 25px;
        font-size: 40px;
        color: $red;
        line-height: 48px;
        span {
          @include text-ellipsis;
          display: inline-block;
          padding-left: 10px;
          font-size: 30px;
          color: $darkBlue;
          line-height: 36px;
          &::after {
            display: block;
            content: '';
            width: 100%;
            height: 5px;
            background-color: $red;
          }
        }
        .name {
          width: 230px;
        }
        .id {
          width: 190px;
          margin-top: 16px;
        }
      }
      .comment {
        margin-top: 60px;
      }
      .poster {
        left: 34.5px;
        width: 575px;
      }
    }
    .page-2 {
      .title {
        margin-top: 60px;
      }
      .comment {
        margin-top: 20px;
      }
      .light {
        @include bg-image-cover($light);
        position: absolute;
        top: -60px;
        z-index: 1;
        width: 550px;
        height: 532px;
        animation: rotate 8s linear;
        animation-iteration-count: infinite;
      }
      .poster {
        img {
          position: relative;
          z-index: 2;
        }
      }
    }
    .page-3 {
      .block {
        margin-top: 30px;
      }
      .honor {
        margin-top: 45px;
        text-align: center;
      }
    }
    .page-4 {
      .comment {
        margin-top: 50px;
      }
      .poster {
        left: 26px;
        width: 590px;
      }
    }
    .page-5 {
      .comment {
        margin-top: 105px;
        p {
          font-size: 45px;
          text-align: center;
          strong {
            font-size: 45px;
          }
        }
      }
    }
    .page-6 {
      .comment {
        margin-top: 106px;
        p {
          font-size: 50px;
          text-align: center;
          line-height: 60px;
        }
      }
      .poster {
        left: 26px;
        width: 590px;
      }
    }
  }
  body[data-webp='support'] {
    #archives {
      .page {
        background-image: url($paper + '?imageMogr2/format/webp');
        .page-inner {
          background-image: url($border + '?imageMogr2/format/webp');
        }
      }
      .page-2 {
        .light {
          background-image: url($light + '?imageMogr2/format/webp');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Archives.vue